/**
 * 現在 location の :lang セグメントだけを `next` に差し替えた URL を返す。
 *
 * 入力例: pathname=/ja/u/acme/202606 search=?t=x next=en
 * 出力例: /en/u/acme/202606?t=x
 *
 * pathname の最初のセグメント (lang 相当) を `next` に置換するだけで、
 * 配下のパスは維持する。トップ (`/ja` のみ) でも安全に `/en` を返す。
 */
export function buildLocaleSwitchPath(
  pathname: string,
  search: string,
  hash: string,
  next: string,
): string {
  const rest = pathname.split("/").slice(2).join("/");
  return `/${next}${rest ? `/${rest}` : ""}${search}${hash}`;
}
